import React from "react";

const OverviewBlockLikes = (props) => {
  const { dataBlock, darkMode, renderIcon, renderValue, renderTrend } = props;

  return (
    <div
      className={
        darkMode
          ? "overviewblock-likes subblock card_dark"
          : "overviewblock-likes subblock card_light"
      }>
      <div className="overviewblock-likes-title_text dashboard_dark_secondarytext">
        Likes
      </div>
      <div className="overviewblock-likes-title_icon">
        {" "}
        {renderIcon(dataBlock.title)}
      </div>
      <div
        className={
          darkMode
            ? "overviewblock-likes-data_value dashboard_dark_maintext"
            : "overviewblock-likes-data_value dashboard_light_maintext"
        }>
        {renderValue(dataBlock.likesCurrent)}
      </div>
      <div className="overviewblock-likes-data_trend trend">
        {renderTrend(dataBlock.likesLast, dataBlock.likesCurrent)}
      </div>
    </div>
  );
};

export default OverviewBlockLikes;
